import React from 'react'
import { useTranslation } from 'react-i18next'

function TotalHitsZero() {
  const { t } = useTranslation()

  return (
    <div>
      <h2 className="heading-component u-text-xl u-leading-tiny u-font-weight-300">
        {t('No search results found')}
      </h2>
    </div>
  )
}

export default TotalHitsZero
